import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import ParticipantDetail from "@/pages/ParticipantDetail";
import Imports from "@/pages/Imports";
import EmailTemplate from "@/pages/EmailTemplate";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Teachers from "@/pages/Teachers";
import AuditLog from "@/pages/AuditLog";
import Reports from "@/pages/Reports";
import PublicPortal from "@/pages/PublicPortal";
import CalendarPage from "@/pages/CalendarPage";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-slate-400" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/p/:token" element={<PublicPortal />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/calendario" element={<Protected><CalendarPage /></Protected>} />
          <Route path="/corsi" element={<Protected><Courses /></Protected>} />
          <Route path="/corsi/:id" element={<Protected><CourseDetail /></Protected>} />
          <Route path="/iscrizioni/:eid" element={<Protected><ParticipantDetail /></Protected>} />
          <Route path="/importazioni" element={<Protected><Imports /></Protected>} />
          <Route path="/email" element={<Protected><EmailTemplate /></Protected>} />
          <Route path="/segnalazioni" element={<Protected><Reports /></Protected>} />
          <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
          <Route path="/impostazioni" element={<Protected><Settings /></Protected>} />
          <Route path="/utenti" element={<Protected><Users /></Protected>} />
          <Route path="/docenti" element={<Protected><Teachers /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
